module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_we3solutions1.80be98a4.gif";